import { events as eventsApi } from '../../api/endpoints';
import { ScreenError, ScreenLoader, SubScreen } from '../../components/layout/Screens';
import { EmptyState } from '../../components/ui/Bits';
import { useAsync } from '../../hooks/useAsync';
import { EventCard } from '../../components/EventCard';
import { t } from '../../i18n';

/**
 * Les evenements que j'ai masques.
 *
 * Masquer etait jusqu'ici un geste sans retour : l'evenement quittait le
 * feed, l'agenda et mes listes, et plus rien ne permettait de le
 * retrouver. Cet ecran est la porte de sortie — on ouvre la fiche, et
 * c'est depuis son menu qu'on le remet en circulation.
 */
export function HiddenEventsScreen() {
  const { data, loading, error, reload } = useAsync(() => eventsApi.hidden(), [], 'hidden-events');

  return (
    <SubScreen title={t.sorties.masques.titre}>
      {loading && <ScreenLoader />}
      {error && <ScreenError message={error} onRetry={reload} />}

      {data && data.length === 0 && (
        <EmptyState
          title={t.sorties.masques.aucun}
          hint={t.sorties.masques.aucunAide}
        />
      )}

      {data && data.length > 0 && (
        <>
          <p className="pr-intro">{t.sorties.masques.remettre}</p>

          <div className="ev-mine__list">
            {data.map((event) => (
              <EventCard key={event.id} event={event} />
            ))}
          </div>
        </>
      )}
    </SubScreen>
  );
}
